import React from 'react';
import { t } from 'i18next';
import CustomMiniCard from '../../../../components/CustomMiniCard';
import NotInformation from '../../../../components/NotInformation';
import { statusColor } from '../../../../enums/statusColorEnum';
import { getDateFormat } from '../../../../Apis/functions';
import { status } from '../../../../enums/statusEnum';
import RowCardText from '../../../../components/RowCardText';
import CustomChip from '../../../../components/CustomChip';

const IncomingOrders = ({ list, userDataTransformSupplierEmployee, userDataTransformSupplierVehicle }) => {

    return (<>
        {list?.length > 0 ?
            <>
                {list?.map((order) => {
                    return (
                        <CustomMiniCard>
                            <div className='px-0 d-flex justify-content-between'>
                                <div className='ibl-item-description-green'>{`${t('Folio')} # ${order?.folio || '-'}`}</div>

                                <CustomChip
                                    background={statusColor[order?.statusId]}
                                    legend={t(status[order?.statusId]).toUpperCase() || '-'}
                                />

                            </div>

                            <div className='ibl-item-description-green'>{t('courier_information')}</div>
                            <RowCardText title={t('company')} value={order?.supplierCompanyAcronym + ' | ' + order?.supplierCompanyName} />
                            <RowCardText title={t('employee')} value={order?.supplierEmployeeId === null ? '-' : userDataTransformSupplierEmployee([order])[0].label} />
                            <RowCardText title={t('vehicle')} value={order?.supplierVehicleId === null ? '-' : userDataTransformSupplierVehicle([order])[0].label} />

                            <div className='ibl-item-description-green'>{t('delivery_information')}</div>
                            <RowCardText title={t('eta')} value={getDateFormat(order.eta, true)} />
                            <RowCardText title={t('item')} value={order?.item || '-'} />
                            <RowCardText title={t('description')} value={order?.description || '-'} />

                        </CustomMiniCard>
                    );
                })}
            </>
            :
            <NotInformation text={t('no_information')} card={true} />
        }
    </>);
}

export default IncomingOrders;
